import Loadable from '../../components/loadable';

const EditContactForms = Loadable({
  loader: () => import('react/pages/contact_forms/edit_contact_forms/edit_contact_forms'),
});

angular.module('gym').value('EditContactForms', EditContactForms);
